// removed by extract-text-webpack-plugin
module.exports = {"base":"ReasonItem_base--1JYrY","input":"ReasonItem_input--2R71q","check":"ReasonItem_check--rWx0s","isChecked":"ReasonItem_isChecked--3_S8c","caption":"ReasonItem_caption--3Obyt"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLeaving/components/ReasonItem/ReasonItem.scss
// module id = 2412
// module chunks = 11